export const CONTENT_RATINGS = [
  { value: 'G', label: 'G - General Audiences', description: 'All ages admitted' },
  { value: 'PG', label: 'PG - Parental Guidance', description: 'Some material may not be suitable for children' },
  { value: 'PG-13', label: 'PG-13 - Parents Strongly Cautioned', description: 'Some material may be inappropriate for children under 13' },
  { value: 'R', label: 'R - Restricted', description: 'Under 17 requires accompanying parent or adult guardian' },
  { value: 'NC-17', label: 'NC-17 - No One 17 and Under Admitted', description: 'No one 17 and under admitted' },
  { value: '14A', label: '14A - 14 Accompaniment', description: 'Persons under 14 years of age must be accompanied by an adult' },
  { value: '18A', label: '18A - 18 Accompaniment', description: 'Persons under 18 years of age must be accompanied by an adult' },
] as const;

export type ContentRating = typeof CONTENT_RATINGS[number]['value'];
